import { render, staticRenderFns } from "./ClientActivity.vue?vue&type=template&id=9db39f10&scoped=true&lang=pug"
import script from "./ClientActivity.vue?vue&type=script&lang=js"
export * from "./ClientActivity.vue?vue&type=script&lang=js"
import style0 from "./ClientActivity.vue?vue&type=style&index=0&id=9db39f10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9db39f10",
  null
  
)

/* custom blocks */
import block0 from "./ClientActivity.vue?vue&type=custom&index=0&blockType=router"
if (typeof block0 === 'function') block0(component)

export default component.exports